import React from 'react';
import styled from "styled-components";
import { BodyRegular } from "../atoms/fonts/Body";
import Icon, { IconTypes } from "../atoms/icon/Icon";
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  flexRender,
  SortingState,
  ColumnDef,
} from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

export function SortableTable(props: Props) {
  const {columns, data, initialState} = props;
  const {t} = useTranslation();

  const [sorting, setSorting] = React.useState<SortingState>(
    initialState?.sortBy?.map((s: any) => ({ id: s.id, desc: s.desc })) ?? []
  );

  const table = useReactTable({
    columns,
    data,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  const hasTranslationProps = (col: any) => {
    return !!col.columnDef.translationProps;
  }

  return (
    <Styles>
      <table>
        <thead>
        {table.getHeaderGroups().map(headerGroup => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map(header => (
              <th key={header.id}
                  onClick={header.column.getToggleSortingHandler()}
                  style={{ cursor: header.column.getCanSort() ? 'pointer' : 'default' }}>
                <HeaderCell>
                  <BodyRegular weight={600}>
                    {hasTranslationProps(header.column)
                      ? t(flexRender(header.column.columnDef.header, header.getContext()) as string, header.column.columnDef.translationProps)
                      : t(flexRender(header.column.columnDef.header, header.getContext()) as string)}
                  </BodyRegular>
                  {header.column.getIsSorted()
                    ? header.column.getIsSorted() === 'desc'
                      ? <Icon icon={IconTypes.Down} />
                      : <Icon icon={IconTypes.Up} />
                    : <Icon icon={IconTypes.Previous} />}
                </HeaderCell>
              </th>
            ))}
          </tr>
        ))}
        </thead>
        <tbody>
        {table.getRowModel().rows.map(row => (
          <tr key={row.id}>
            {row.getVisibleCells().map(cell => (
              <td key={cell.id}>
                <BodyRegular>{flexRender(cell.column.columnDef.cell, cell.getContext())}</BodyRegular>
              </td>
            ))}
          </tr>
        ))}
        </tbody>
      </table>
    </Styles>
  )
}

const Styles = styled.div`
`

const HeaderCell = styled.div`
  display: flex;
  i {
    margin-left: 8px;
  }
`

interface Props {
  data: any;
  columns: ColumnDef<any, any>[];
  initialState?: any;
}
